import React, { useState, useEffect, useMemo } from 'react';
import PageHeader from '@/components/PageHeader/index';
import { Box } from '@mui/material';
import { Message } from '@alifd/next';
import client from '@/lib/feathers';
import FinanceCommunityFunc from './FinanceCommunityFunc/index';
import FinanceCommunityList from './FinanceCommunityList/index';

export default function FinanceCommunity() {
  const [isUpdate, setIsUpdate] = useState(false);
  const [subjects, setSubjects] = useState([]);
  const [financeCommunityData, setFinanceCommunityData] = useState([]);
  const [filter, setFilter] = useState({});

  const financeCommunity = useMemo(
    () => client.service('financeCommunity'),
    []
  );

  const accountingSubjects = useMemo(
    () => client.service('accountingSubjects'),
    []
  );

  useEffect(() => {
    (async () => {
      const res = await financeCommunity.find({ query: filter });
      setFinanceCommunityData(res.data);
    })();
    setIsUpdate(false);
  }, [filter, setFinanceCommunityData, isUpdate, financeCommunity]);

  useEffect(() => {
    (async () => {
      try {
        const res = await accountingSubjects.find({});
        setSubjects(res.data.sort((a, b) => a.subjectCode - b.subjectCode));
      } catch (error) {
        Message.error('讀取會計科目失敗');
      }
    })();
    setIsUpdate(false);
  }, [setSubjects, isUpdate, setIsUpdate, accountingSubjects]);

  const nestedSubjects = useMemo(() => {
    const returnData = [];
    if (subjects.length > 0) {
      subjects.forEach((subject) => {
        if (subject.subjectCode.slice(2, 4) === '00') {
          returnData.push({
            ...subject,
            key: subject.subjectCode,
          });
        } else {
          const parentSubject = returnData.find((item) => {
            if (
              item.subjectCode.slice(0, 2) ===
                subject.subjectCode.slice(0, 2) &&
              item.subjectCode.slice(2, 4) === '00'
            ) {
              return true;
            }
            return false;
          });
          if (!parentSubject.children) {
            parentSubject.children = [];
          }
          parentSubject.children.push({
            ...subject,
            key: subject.subjectCode,
          });
        }
      });
    }
    return returnData;
  }, [subjects]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
      }}
    >
      <PageHeader
        breadcrumbs={[{ name: '財務管理' }, { name: '社區財務列表' }]}
        title="社區財務列表"
      />
      <FinanceCommunityFunc
        {...{
          setIsUpdate,
          subjects,
          nestedSubjects,
          setFilter,
        }}
      />
      <FinanceCommunityList
        {...{
          financeCommunity,
          financeCommunityData,
          subjects,
          setIsUpdate,
          nestedSubjects,
        }}
      />
    </Box>
  );
}
